import axios from 'axios';
import { debugLog } from './debug';

// Determine API URL based on environment
let BACKEND_URL;
if (process.env.REACT_APP_API_URL) {
  // Use environment variable if provided (production or staging)
  BACKEND_URL = process.env.REACT_APP_API_URL;
} else if (process.env.NEXT_PUBLIC_API_URL) {
  // For Vercel deployment
  BACKEND_URL = process.env.NEXT_PUBLIC_API_URL;
} else {
  // Default to localhost for development
  BACKEND_URL = 'http://localhost:5001';
}

// Function to test the connection to the backend
export const testBackendConnection = async () => {
  try {
    debugLog('Testing connection to backend...');
    
    // Try to connect to the backend health endpoint
    const response = await axios.get(`${BACKEND_URL}/api/test`, {
      timeout: 5000 // 5 second timeout
    });
    
    debugLog('Backend connection successful:', response.data);
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Backend connection failed:', error.message);
    
    // Provide more detailed error information
    let errorDetails = 'Unknown error';
    
    if (error.code === 'ECONNREFUSED') {
      errorDetails = 'Connection refused. Make sure the backend server is running on port 5001.';
    } else if (error.code === 'ETIMEDOUT') {
      errorDetails = 'Connection timed out. The backend server might be overloaded or not responding.';
    } else if (error.response) {
      // The request was made and the server responded with a status code outside of 2xx
      errorDetails = `Server responded with status ${error.response.status}: ${error.response.statusText}`;
    } else if (error.request) {
      // The request was made but no response was received
      errorDetails = 'No response received from the server.';
    }
    
    return {
      success: false,
      error: error.message,
      details: errorDetails
    };
  }
}; 
